import "@nike/eds/dist/index.css";
import React, {useContext} from "react";
import SnackbarContext from "./providers/snackbar-context";
import {Route, Routes} from "react-router-dom";
import ApplicationSnackbar from "./components/shared/ApplicationSnackbar";
import {Overview} from "./components/overview/overview";
import {DSLeftCWService} from "./components/DirectShipmentLeftCustomsWarehouse/DSLeftCWService";

const dSLeftCWService: DSLeftCWService = new DSLeftCWService()

export function App({history, locationTracker, host, permissions}) {
    const snackbarCtx = useContext(SnackbarContext);

    return (
            <div>
                <Routes>
                    <Route path="/trigger"
                        element={<Overview dSLeftCWService={dSLeftCWService} permissions={permissions}/>}/>
                </Routes>
                {snackbarCtx.isDisplayed && <ApplicationSnackbar/>}
            </div>
    );
}

export default App;
